import { useEffect, useState } from 'react';
import { Box, Divider, Grid, IconButton, Stack, Typography, styled } from '@mui/material';
import TelegramLoginButton from 'react-telegram-login';
import { useSnackbar } from 'notistack';
import { LoginSocialFacebook } from 'reactjs-social-login';
import useLocales from '../../../../hooks/useLocales';

import { useDispatch, useSelector } from '../../../../redux/store';
import { openLoginSignup } from '../../../../redux/slices/authPages';

import Login from './Login';
import Register from './Register';
import CustomModal from '../../../../components/CustomModal';
import Image from '../../../../components/Image';
import conObj from '../../../../utils/connection-assistant';
import useAuth from '../../../../hooks/useAuth';

import palette from '../../../../theme/palette';
import { telegramId } from '../../../../config';
import useResponsive from '../../../../hooks/useResponsive';

const TabButtonStyled = styled(Box)(({ theme, isActive, isLeft = true }) => ({
  backgroundColor: isActive ? 'rgb(37, 56, 87)' : 'rgb(8, 15, 28)',
  position: 'absolute',
  left: isLeft ? '0px' : 'unset',
  right: isLeft ? 'unset' : '0px',
  zIndex: isActive ? 1 : 0,
  width: '53%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  clipPath: `url(#${isLeft ? 'clipWaveLeft' : 'clipWaveRight'})`,
  WebkitClipPath: `url(#${isLeft ? 'clipWaveLeft' : 'clipWaveRight'})`,
}));

const ContainerHeader = styled(Box)(({ theme }) => ({
  position: 'absolute',
  width: '100%',
  bottom: '1.4rem',
  display: 'flex',
  // padding: '1rem',
}));

const ContainerHeaderWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginLeft: '1rem',
}));

const CustomHr = ({ style }) => (
  <hr style={{ borderTop: `0.03rem solid ${palette.visitor.dialog.hr}`, borderBottom: 'none', height: 1, ...style }} />
);

const SocialIcon = styled(Image)(({ theme }) => ({
  width: '35px',
  height: '35px',
  borderRadius: '5px',
  cursor: 'pointer',
}));

const LoginSignupDialog = ({ setOpenForgotPasswordDialog }) => {
  const { login } = useAuth();

  const dispatch = useDispatch();

  const { isOpenLoginSignupDialog } = useSelector((x) => x.authPages);

  const [activeTab, setActiveTab] = useState('1');

  const [authData, setAuthData] = useState(null);

  const { enqueueSnackbar } = useSnackbar();

  const { translate, currentLang } = useLocales();

  const isSm = useResponsive('down', 'lg');

  useEffect(() => {
    if (isOpenLoginSignupDialog?.isLogin) setActiveTab('1');
    if (!isOpenLoginSignupDialog?.isLogin) setActiveTab('2');
  }, [isOpenLoginSignupDialog]);

  const handleTelegramLogin = () => {
    window?.Telegram?.Login.auth({ bot_id: telegramId, request_access: true }, (data) => {
      if (!data) {
        // authorization failed
      }

      // Here you would want to validate data like described there https://core.telegram.org/widgets/login#checking-authorization
      thirdPartyAuth(data);
    });
  };

  const thirdPartyAuth = async (response, type = 'telegram') => {
    try {
      const apiResponse = await conObj.post('users/tpp_login.json', {
        'user_third_party_login-data': JSON.stringify(response),
        'user_third_party_login-platform': type,
      });

      let isSuccess = false;

      const responseData = apiResponse?.data?.data;

      console.log(response, responseData?.registerNow);

      if (responseData?.registerNow) {
        setAuthData({ ...response, platform: type });
        setActiveTab('2');
        isSuccess = true;
      }

      if (!responseData?.registerNow && responseData?.token) {
        await login(
          {},
          {
            token: responseData?.token,
            firstName: responseData?.first_name,
            username: responseData?.username,
            fullName: responseData?.full_name,
            lastName: responseData?.last_name,
            email: responseData?.email,
          }
        );
        isSuccess = true;
      }

      if (!isSuccess) {
        throw new Error(`Login to ${type} failed!`);
      }
    } catch (error) {
      enqueueSnackbar(error?.message, { variant: 'error' });
    }
  };

  return (
    <CustomModal
      fullScreen={isSm}
      maxWidth={'lg'}
      open={isOpenLoginSignupDialog.open}
      PaperPropsSx={{ height: '669px' }}
      onClose={() => dispatch(openLoginSignup({ open: false, isLogin: true }))}
    >
      <Grid container sx={{ height: '100%' }}>
        <Grid item sm={12} md={7} sx={{ display: { xs: 'none', sm: 'none', md: 'flex' } }}>
          <Box sx={{ position: 'relative', width: '100%', overflow: 'hidden', height: '100%', p: 2 }}>
            <Box
              sx={{
                display: 'flex',
                height: '100%',
                background: 'linear-gradient(0deg, rgb(7, 20, 44) -5.86%, rgb(38, 58, 89) 104.05%)',
                borderRadius: '8px',
                padding: 2,
                width: '100%',
              }}
            >
              <Image
                // src={
                //   currentLang?.value === 'bn'
                //     ? require('../../../../assets/visitor/visitor_banner_bn.jpg')
                //     : require('../../../../assets/visitor/visitor_banner_en.jpg')
                // }
                src={require('../../../../assets/visitor/visitor_banner_en.webp')}
                imgSx={{ objectFit: 'unset' }}
              />
            </Box>

            {/* <ContainerHeader
              sx={{
                justifyContent: 'center',
              }}
            >
              <ContainerHeaderWrapper
                sx={{
                  alignItems: 'end',
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: '1.2rem', sm: '1.3rem', md: '1.4rem' },
                    fontWeight: 500,
                    textShadow: '1px 2px 5px black',
                  }}
                >
                  {translate(
                    isOpenLoginSignupDialog.isLogin
                      ? translate('welcome_back_good_luck')
                      : translate('welcome_to_best_casino')
                  )}
                </Typography>
              </ContainerHeaderWrapper>
            </ContainerHeader> */}
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={5}>
          <Box
            sx={{
              overflow: 'hidden',
              color: 'white',
              // mt: '-3rem',
              position: 'relative',
              p: 2,
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {/* </Box> */}
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                position: 'relative',
                height: '47px',
                borderTopLeftRadius: 8,
                borderTopRightRadius: 8,
                overflow: 'hidden',
              }}
            >
              {/* Clip Left */}
              <svg width="0" height="0" style={{ position: 'absolute' }}>
                <defs>
                  <clipPath id="clipWaveLeft" clipPathUnits="objectBoundingBox">
                    <path d="M0 .1786 C0 .0799 .0218 0 .0487 0 H.8555 C.8754 0 .8931 .0437 .9005 .1107 L1 1 H0 V.1786 Z" />
                  </clipPath>
                </defs>
              </svg>
              <TabButtonStyled onClick={() => setActiveTab('1')} isActive={activeTab === '1'}>
                {translate('login')}
              </TabButtonStyled>
              {/* Clip Right */}
              <svg width="0" height="0" style={{ position: 'absolute' }}>
                <defs>
                  <clipPath id="clipWaveRight" clipPathUnits="objectBoundingBox">
                    <path d="M0.0558 0.1561 C0.0609 0.0642 0.0786 0 0.0988 0 H0.9333 C0.9979 0 1 0.2183 1 0.2083 V1 H0 L0.0558 0.1561 Z" />
                  </clipPath>
                </defs>
              </svg>
              <TabButtonStyled onClick={() => setActiveTab('2')} isActive={activeTab === '2'} isLeft={false}>
                {translate('register')}
              </TabButtonStyled>
            </Box>
            <Box
              sx={{
                p: 3,
                background: 'linear-gradient(0deg, rgb(7, 20, 44) -5.86%, rgb(38, 58, 89) 104.05%)',
                borderBottomRightRadius: 8,
                borderBottomLeftRadius: 8,
                flex: 1,
              }}
            >
              {activeTab === '1' ? (
                <Login
                  setOpenForgotPasswordDialog={setOpenForgotPasswordDialog}
                  setActiveTab={setActiveTab}
                  setAuthData={setAuthData}
                />
              ) : (
                <Register setActiveTab={setActiveTab} authData={authData} />
              )}
              {/* <Box>
            <Stack direction="row" alignItems={'center'} sx={{ mt: 4 }}>
              {!authData || activeTab === '1' ? (
                <>
                  <CustomHr style={{ flexGrow: 1 }} />
                  <Typography sx={{ px: 1, fontSize: '0.8rem', fontWeight: 500 }}>
                    {translate('login_directly')}
                  </Typography>
                  <CustomHr style={{ flexGrow: 1 }} />
                </>
              ) : (
                ''
              )}
            </Stack>
          </Box>
          {!authData || activeTab === '1' ? (
            <Box>
              <Stack
                direction={'row'}
                justifyContent={'center'}
                alignItems={'center'}
                spacing={1}
                sx={{ px: 1, pt: 0.5 }}
              >
                <IconButton size="medium">
                  <Iconify icon="ri:google-fill" sx={{ fontSize: '1.5rem' }} />
                </IconButton>
                <IconButton size="medium">
                  <Iconify icon="mingcute:telegram-fill" sx={{ fontSize: '1.5rem' }} />
                </IconButton>
              </Stack>
            </Box>
          ) : (
            ''
          )} */}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </CustomModal>
  );
};

export default LoginSignupDialog;
